/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersactive1Inputs */

const en_membersactive1 = /** @type {(inputs: Membersactive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

const de_membersactive1 = /** @type {(inputs: Membersactive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder`)
};

/**
* | output |
* | --- |
* | "Members" |
*
* @param {Membersactive1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersactive1 = /** @type {((inputs?: Membersactive1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersactive1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersactive1(inputs)
	return de_membersactive1(inputs)
});
export { membersactive1 as "membersActive" }